import React, { useContext } from "react";
import { Col, Row }          from "react-bootstrap";
import styled                from "styled-components";
import { OrderContext }      from "~/contexts/OrderContext";
import { toDollars }         from "~/helpers/currency";

const OrderLedgerContainer = styled.div`
  input.tax-rate {
    width: 100%;
    border: 1px solid #ddd;
    padding: 4px;
    border-radius: 2px;
  }

  .spacer,
  .total {
    max-width: 100px;
  }

  @media print {
    .tax_rate {
      display: none;
    }
    input {
      border: none;
    }
  }
`;

export const OrderLedger = () => {
  const { order, ledger, dispatch } = useContext(OrderContext);

  const onTaxRateChange = ({ currentTarget: { value } }) => {
    dispatch({
      type: "TAX_UPDATED",
      payload: value,
    });
  };

  return (
    <OrderLedgerContainer>
      <Row className="py-2">
        <Col />
        <Col>
          <Row className="py-1 tax_rate">
            <Col className="text-right">Tax Rate:</Col>
            <Col className="text-left total">
              <input
                onChange={onTaxRateChange}
                className="tax-rate"
                value={order?.attributes?.tax_rate}
              />
            </Col>
          </Row>
          <Row className="py-1">
            <Col className="text-right">Tax Due:</Col>
            <Col className="text-left total">
              {toDollars(
                (order?.attributes?.tax_rate / 100) * ledger?.subtotal
              )}
            </Col>
          </Row>
          <Row className="py-1">
            <Col className="text-right">Subtotal:</Col>
            <Col className="text-left total">{toDollars(ledger?.subtotal)}</Col>
          </Row>
          <Row className="py-1">
            <Col className="text-right">Amount Due:</Col>
            <Col className="text-left total">
              {toDollars(ledger?.total_due)}
            </Col>
          </Row>
        </Col>
        <Col className="spacer" />
      </Row>
    </OrderLedgerContainer>
  );
};
